module.exports = __webpack_public_path__ + "static/media/globo_tex.c99911f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/globo/globo_tex.png
// module id = 141
// module chunks = 0